import { useEffect, useMemo, useState } from 'react'
import MiastoService from '@/services/MiastoService'

function formatMiastoLabel(item) {
	const miastoName = item?.nazwa || '-'
	const gminaName = item?.id_gmina?.nazwa || ''
	const powiatName = item?.id_powiat?.nazwa || ''
	const wojewodztwoName = item?.id_wojewodztwo?.nazwa || item?.id_powiat?.id_wojewodztwo?.nazwa || ''

	const locationParts = [gminaName, powiatName, wojewodztwoName].filter(Boolean)
	return locationParts.length > 0 ? `${miastoName} (${locationParts.join(', ')})` : miastoName
}

export default function useMiastoFilterModal(isOpen, selectedMiastoId, idGmina = null, idPowiat = null, idWojewodztwo = null) {
	const [searchTerm, setSearchTerm] = useState('')
	const [items, setItems] = useState([])
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState(null)
	const [activeId, setActiveId] = useState(selectedMiastoId || '')

	useEffect(() => {
		if (!isOpen) return
		setActiveId(selectedMiastoId || '')
	}, [isOpen, selectedMiastoId])

	useEffect(() => {
		if (!isOpen) return
		let cancelled = false
		const loadItems = async () => {
			setLoading(true)
			setError(null)
			const query = (searchTerm || '').trim()
			const filters = {}
			if (idGmina) filters.id_gmina = idGmina
			if (idPowiat) filters.id_powiat = idPowiat
			if (idWojewodztwo) filters.id_wojewodztwo = idWojewodztwo
			const options = {
				limit: 200,
				sortColumn: 'nazwa',
				sortDirection: 'asc',
				filters,
			}
			const result = query ? await MiastoService.search(query, options) : await MiastoService.getAll(options)
			if (cancelled) return
			if (result?.error) {
				setError(result.error)
				setItems([])
			} else {
				setItems(Array.isArray(result?.data) ? result.data : [])
			}
			setLoading(false)
		}
		const timer = setTimeout(loadItems, 200)
		return () => {
			cancelled = true
			clearTimeout(timer)
		}
	}, [isOpen, searchTerm, idGmina, idPowiat, idWojewodztwo])

	const selectedName = useMemo(() => {
		const selected = items.find(item => (item?._id || item?.id) === activeId)
		return selected ? formatMiastoLabel(selected) : ''
	}, [items, activeId])

	return {
		searchTerm,
		setSearchTerm,
		items,
		loading,
		error,
		activeId,
		setActiveId,
		selectedName,
		labelAccessor: formatMiastoLabel,
		clearFilter: () => setActiveId(''),
	}
}
